<template>
	<div v-if="!window.PHP.bot && bets.length !== 0" :class="{'pt-6 pb-2 xl:pb-0 xl:pt-8': showTopBorder, 'border-b border-zt-light' : showBottomBorder}">
		<hr v-if="showTopBorder && analyticName === ''" class="border-zt-light">
		<div class="mb-4 mt-6 xl:my-8" :class="{'px-2 xl:py-3 xl:rounded-zt xl:border xl:border-zt-light xl:bg-zt-light/5 xl:px-4' : showTopBorder}">
			<div>
				<div class="!mb-2 xl:text-xl">
					Najciekawsze propozycje z
					<a class="no-default-style text-zt-red zt-hover" :data-count-click-category="analyticType"
             :data-count-click="analyticName !== '' ? analyticName : 'SHORTCODE PIŁKA TD - Nagłówek Typy Dnia'" href="/typy-dnia/">Typów&nbsp;Dnia</a>
				</div>
				<div class="w-full bg-zt-light/35 border border-zt-light rounded-zt">
					<div v-for="bet in bets" :key="bet.id"
					   class="flex flex-col zt-hover pt-[6px] relative border-b border-zt-light last-of-type:border-b-0 ">
            <div class="flex justify-between  items-center px-3">
              <div class="flex gap-x-[27px] items-center">
                <img
                    @error="handleUserAvatarError($event)"
                    class="ml-[11px] rounded-full w-[21px] h-[21px] max-w-[21px] max-h-[21px] object-cover" width="21" height="21" :src="bet.user_avatar" />
                <span class="text-xs font-semibold">
                  {{ bet.display_name }}
                </span>
              </div>
              <div
                  style="box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);"
                  class="text-xs font-semibold w-[54px] grid place-items-center rounded-[8px] py-[3px] bg-[#232C38]">
                {{ Math.round((bet.author_stats.ratio * 100).toFixed(1)) + '%' }}
              </div>
            </div>
            <hr class="border-t mt-[7px] mx-3 border-zt-light border-dashed" />
            <div class="flex gap-3 items-center p-2 pr-3 h-[51px]
                 transition-colors hover:bg-zt-light/3">
              <a :data-count-click-category="analyticType"
                 :data-count-click="analyticName !== '' ? analyticName : 'SHORTCODE PIŁKA TD - Typ'"
                 class="no-default-style absolute top-0 bottom-0 left-0 right-0 opacity-0" rel="nofollow"
                 :href="`/${bet.post_name}/#comment-${bet.id}`">
                {{ bet.match_name }} - {{ bet.type }}
              </a>
              <div class="text-zt-more text-xs flex flex-col items-center justify-around basis-[50px] shrink-0">
                <div>{{ dateFormatted(bet) }}</div>
                <div>{{ DateTime.fromFormat(bet.hour, 'yyyy-MM-dd HH:mm:ss').toFormat('HH:mm') }}</div>
              </div>
              <div class="flex flex-col gap-1 grow shrink overflow-hidden">
                <div class="flex items-center gap-1 basis-full grow-0">
              <span class="inline-block">
                <img class="!mb-0 w-[13px] h-[13px] opacity-70"
                     :src="'/wp-content/themes/zawodtyper/assets/images/dyscypliny/piłkanożna.svg'" alt="Piłka nożna">
              </span>
                  <span class="text-zt-more text-xs whitespace-nowrap text-ellipsis overflow-hidden">
                <span v-if="window.size.desktop">Piłka Nożna |</span> {{ bet.match_name }}
              </span>
                </div>
                <div class="text-xs text-ellipsis overflow-hidden whitespace-nowrap">
                  <span v-if="window.size.desktop">Typ:</span> {{ bet.type }}
                </div>
              </div>
              <div class="ml-auto flex gap-1.5 items-center basis-[50px] justify-start">
                <span>
                  <svg v-if="!(+bet.result)" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="15" height="15" rx="7.5" fill="#AEAEAE"/>
                    <path
                      d="M4.375 10.9821C4.375 11.0532 4.40244 11.1213 4.45127 11.1715C4.50011 11.2218 4.56635 11.25 4.63542 11.25H10.3646C10.4337 11.25 10.4999 11.2218 10.5487 11.1715C10.5976 11.1213 10.625 11.0532 10.625 10.9821C10.625 10.9111 10.5976 10.843 10.5487 10.7927C10.4999 10.7425 10.4337 10.7143 10.3646 10.7143H9.84375V10.1786C9.84386 9.72373 9.71886 9.27814 9.4832 8.89327C9.24754 8.5084 8.91084 8.19996 8.51198 8.00357C8.36094 7.92911 8.28125 7.80161 8.28125 7.6875V7.3125C8.28125 7.19839 8.36146 7.07089 8.51198 6.99643C8.91084 6.80004 9.24754 6.4916 9.4832 6.10673C9.71886 5.72186 9.84386 5.27627 9.84375 4.82143V4.28571H10.3646C10.4337 4.28571 10.4999 4.25749 10.5487 4.20726C10.5976 4.15703 10.625 4.0889 10.625 4.01786C10.625 3.94682 10.5976 3.87869 10.5487 3.82845C10.4999 3.77822 10.4337 3.75 10.3646 3.75H4.63542C4.56635 3.75 4.50011 3.77822 4.45127 3.82845C4.40244 3.87869 4.375 3.94682 4.375 4.01786C4.375 4.0889 4.40244 4.15703 4.45127 4.20726C4.50011 4.25749 4.56635 4.28571 4.63542 4.28571H5.15625V4.82143C5.15614 5.27627 5.28114 5.72186 5.5168 6.10673C5.75246 6.4916 6.08916 6.80004 6.48802 6.99643C6.63906 7.07089 6.71875 7.19839 6.71875 7.3125V7.6875C6.71875 7.80161 6.63854 7.92911 6.48802 8.00357C6.08916 8.19996 5.75246 8.5084 5.5168 8.89327C5.28114 9.27814 5.15614 9.72373 5.15625 10.1786V10.7143H4.63542C4.56635 10.7143 4.50011 10.7425 4.45127 10.7927C4.40244 10.843 4.375 10.9111 4.375 10.9821ZM5.67708 10.7143V10.1786C5.67699 9.82478 5.77421 9.47817 5.95753 9.1788C6.14084 8.87944 6.40276 8.63952 6.71302 8.48679C6.99062 8.34964 7.23958 8.06357 7.23958 7.68804V7.31196C7.23958 7.31196 7.33333 7.36607 7.5 7.36607C7.66667 7.36607 7.76042 7.3125 7.76042 7.3125V7.6875C7.76042 8.06304 8.00937 8.34964 8.28698 8.48679C8.59724 8.63952 8.85916 8.87944 9.04247 9.1788C9.22579 9.47817 9.32301 9.82478 9.32292 10.1786V10.7143H5.67708Z"
                      fill="#344153"/>
                  </svg>
                  <svg v-else xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                    <rect x="1" y="1" width="13" height="13" rx="6.5" fill="white"/>
                    <path d="M15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C5.51088 15 3.60322 14.2098 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5ZM11.2781 4.65937C11.2112 4.59264 11.1314 4.5401 11.0437 4.50489C10.9559 4.46968 10.862 4.45252 10.7675 4.45445C10.673 4.45637 10.5798 4.47734 10.4936 4.5161C10.4073 4.55485 10.3298 4.6106 10.2656 4.68L7.00969 8.82844L5.0475 6.86531C4.91421 6.74111 4.73792 6.6735 4.55576 6.67671C4.3736 6.67992 4.1998 6.75372 4.07098 6.88254C3.94215 7.01137 3.86836 7.18517 3.86515 7.36732C3.86193 7.54948 3.92955 7.72577 4.05375 7.85906L6.53437 10.3406C6.6012 10.4073 6.68078 10.4599 6.76836 10.4952C6.85594 10.5305 6.94973 10.5477 7.04414 10.546C7.13854 10.5442 7.23163 10.5235 7.31784 10.485C7.40405 10.4465 7.48163 10.391 7.54594 10.3219L11.2884 5.64375C11.416 5.51109 11.4865 5.3337 11.4848 5.14965C11.483 4.9656 11.4082 4.78958 11.2781 4.65937Z" fill="#1CC200"/>
                  </svg>
                </span>
                <span class="font-bold text-sm" :class="(+bet.result) ? 'text-[#1CC200]' :'text-white'">
                  {{ formatOddsValue(bet.rate) }}
                </span>
              </div>
            </div>
          </div>
          <div v-if="noRedButtonLink" class="no-default-style p-2 pr-3 h-[51px] border-t border-zt-light">
            <a href="/typy-dnia/" :data-count-click-category="analyticType"
               :data-count-click="analyticName !== '' ? analyticName : 'SHORTCODE PIŁKA TD - Więcej typów'"
               class="no-default-style zt-hover flex gap-1 items-center justify-center h-full mx-auto w-fit">
              <span class="text-xs text-zt-more underline uppercase">Więcej typów</span>
              <svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M10.3722 13.4386L16.0405 6.81108L10.3722 0.183594L9.44646 1.26602L13.5556 6.05148L3.24219 6.05148L3.24219 7.57067L13.5556 7.57067L9.44646 12.3561L10.3722 13.4386Z"
                    fill="#93A3BA"/>
                <path d="M1.29932 6.05078H0L0 7.56998H1.29932L1.29932 6.05078Z" fill="#93A3BA"/>
              </svg>
            </a>
          </div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import utils_mixin from "../../mixins/utils_mixin";

export default {
  name: 'FootballBets',
  inject: ['WP'],
  mixins: [utils_mixin],
  props: {
    noRedButtonLink: {
      type: Boolean,
      default: false,
    },
	  showTopBorder: {
			type: Boolean,
		  default: false,
	  },
	  showBottomBorder: {
		  type: Boolean,
		  default: false,
	  },
    analyticName: {
      type: String,
      default: '',
    },
    analyticType: {
      type: String,
      default: 'football'
    }
  },
  data() {
    return {
      bets: [],
	    loading: true,
    }
  },
  mounted() {
    axios
      .post(this.WP.ajaxUrl, {
        endpoint: 'api_get_football_bets',
      }).then(response => {
        this.bets = response.data.data;
				this.loading = false;
				this.removePlaceholder(this.$attrs.component);
      });
  },
  methods: {
	  formatOddsValue(value) {
		  let valueInt = parseFloat(value);
		  if (valueInt >= 1000) {
			  return '999+';
		  }
		  if (valueInt < 10) {
			  return valueInt.toFixed(2)
		  }
		  if (valueInt >= 10) {
			  value = value.split('.');
				if (value[1] === '00') {
					return `${value[0]}.0`;
				}
				return valueInt.toFixed(2);
		  }
	  },
    dateFormatted(bet) {
      let betDateTime = DateTime.fromFormat(bet.hour, 'yyyy-MM-dd HH:mm:ss');
      let diffDays = betDateTime.startOf('day').diff(DateTime.now().startOf('day'), 'days').as('days');
      switch ( diffDays ) {
        case 0: 
          return "Dziś";
        case 1: 
          return "Jutro";
        case -1: 
          return "Wczoraj";
        default:
          return betDateTime.toFormat('dd.MM.yy');

      }
    }
  },
}
</script>